// Copyright (c) 2022 by Move Closer

import { Module, ModuleContent, ProductData, Related } from '../../contexts'

import { ProductReviewProps } from '../../front/products/molecules/ProductReview'

import { AvailableModuleDriver } from '../allowed'

import { HeadingFormData } from '../partials'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export type ProductReviewsModule = Module<ProductReviewsModuleContent, AvailableModuleDriver.ProductReviews>

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export interface ProductReviewsModuleData extends ModuleContent {
  /**
   * Determines product reviews heading
   */
  heading?: HeadingFormData

  /**
   * Determines product data
   */
  product: ProductData | null

  /**
   * Determines product reviews list
   */
  productReviews: ProductReviewProps[] | null

  /**
   * Determines amount of reviews per page
   */
  reviewsPerPage: number

  /**
   * Determines is pagination showed
   */
  showPagination: boolean
}

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export type ProductReviewsModuleContent = ProductReviewsModuleData

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
// todo: aelia: export interface ProductReviewsModuleContentInput extends Omit<ProductReviewsModuleData, 'reviews' | 'product'>, ModuleContent {
export interface ProductReviewsModuleContentInput extends Omit<ProductReviewsModuleData, 'product'>, ModuleContent {
  product: Related
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum ProductReviewsVersion {
  LoadMore = 'loadMore',
  Paginate = 'paginate'
}
